// src/components/DutyCareNotice.js
import React, { useState } from 'react';
import BrandName from './BrandName';
import RegisterCheck from './RegisterCheck';
import './DutyCareNotice.css';

const DutyCareNotice = ({ variant = 'info' }) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className={`duty-notice duty-${variant}`}>
      <div className="duty-icon">🛡️</div>
      <div className="duty-content">
        <div className="duty-title">Your Legal Duty of Care</div>
        <p className="duty-text">
          UK law requires you to take care who takes your household waste.
          A fine of up to <strong>£600</strong> can apply if that duty is missed.
          Waste carriers on <BrandName inline /> are checked against the public register before they&apos;re approved.
          Scrap collection is free.{' '}
          <RegisterCheck />
        </p>
      </div>
      <button className="duty-dismiss" onClick={() => setDismissed(true)}>✕</button>
    </div>
  );
};

export default DutyCareNotice;
